import { Component, OnInit, HostListener, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationExtras } from '@angular/router';
import { BnplService } from '../../shared/services/bnpl.service';
import { map, Observable, startWith } from 'rxjs';
import { ControlBase } from 'src/app/core/shared/models/control-base';
import { Client } from '../../shared/models/client.model';
import { Router } from '@angular/router';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import Swal from 'sweetalert2';
import { FormComponent } from 'src/app/core/components/form/form.component';
import { MatDialog } from '@angular/material/dialog';
import { DialogComponent } from 'src/app/core/components/dialog/dialog.component';
import { environment } from 'src/environments/environment';
import { IGetUpdateAuthorizationBody } from '../../shared/models/updateAuthorization.model';
import { UpdateAuthorizationService } from '../../shared/services/update-authorization.service';
import { IPostAutoDebitAccountBody } from '../../shared/models/automaticDebits.model';
import { AutomaticDebitService } from '../../shared/services/automatic-debit.service';

@Component({
  selector: 'app-usecupo',
  templateUrl: './usecupo.component.html',
  styleUrls: ['./usecupo.component.css'],
})
export class UseCupoComponent implements OnInit {
  @ViewChild(FormComponent) appFormComponent!: FormComponent;
  isLargeScreen: boolean = false;
  itemSelected = true;
  partnerName: string = localStorage.getItem('partnerName') || '';
  referenPay: string = '';
  controls$: any;
  form!: FormGroup;
  optionsObject: any;
  amountFinance: number = this.bnplService.creditEmit.amountFinance || 0;
  ammount: number = this.bnplService.personalInformation.ammount || 0;
  public selectionBuy$!: Observable<ControlBase<any>[]>;
  public arrayBuys: number[] = [];
  public arrayFees: number[] = [];
  public commerce: string = localStorage.getItem('commerce') || '';
  navigationExtras: NavigationExtras = {};
  desabledButton: boolean = false;
  filterControl = new FormControl();
  filteredOptions: any[] = [];
  originData: any[] = [];
  banksExperian: any = [];
  listBanks: any = [];
  private _requireUpdate: boolean = false;
  private _requireDebit: boolean = false;
  private _automaticDebit: boolean = false;
  storesList = new Map<string, Client[]>();
  storeSelected: Client[] | null = null;
  urlImage: string = environment.urlAwsImg;
  carouselTuto: boolean = true;
  public clientSelected!: Client;
  public branchFinder: string = '';
  public findListBranchs: Client[] | null = null;
  public selectedBranchStore: Client | null = null;
  autoDebitAccountSelected: IPostAutoDebitAccountBody | null = null;

  get requireUpdate(): boolean {
    return this._requireUpdate;
  }

  set requireUpdate(value: boolean) {
    this._requireUpdate = value;
    this.checkIfShouldRunAutomaticDebit();
  }

  get requireDebit(): boolean {
    return this._requireDebit;
  }

  set requireDebit(value: boolean) {
    this._requireDebit = value;
    this.checkIfShouldRunAutomaticDebit();
  }

  get automaticDebit(): boolean {
    return this._automaticDebit;
  }

  set automaticDebit(value: boolean) {
    this._automaticDebit = value;
    this.checkIfShouldRunAutomaticDebit();
  }

  constructor(
    private readonly route: ActivatedRoute,
    public bnplService: BnplService,
    private readonly router: Router,
    private readonly fb: FormBuilder,
    public dialog: MatDialog,
    private updateAuthorizationService: UpdateAuthorizationService,
    private readonly automaticDebitService: AutomaticDebitService
  ) {
    localStorage.setItem('amountFinance', this.amountFinance.toString());
    this.form = this.fb.group({ selectclient: ['', Validators.required] });

    this.bnplService.clients.subscribe((resp: Client[]) => {
      this.filteredOptions = resp;
      this.originData = [...this.filteredOptions];
    });

    this.filterControl.valueChanges
      .pipe(
        startWith(''),
        map((value: string | any) => {
          const filterValue =
            typeof value === 'string' ? value : value?.partnerName || '';
          return this._filter(filterValue);
        })
      )
      .subscribe((filtered) => (this.filteredOptions = filtered));

    this.referenPay = this.bnplService.personalInformation.referenciaPago;
  }

  get storesListEntries(): [string, Client[]][] {
    return Array.from(this.storesList.entries());
  }

  ngOnInit(): void {
    this.handleListStores();
    this.checkWindowSize();
    if (this.commerce === 'true') {
      this.selectionBuy$ = this.bnplService.getSelectionPurchaseFees(
        this.arrayFees
      );
    } else {
      this.selectionBuy$ = this.bnplService.getSelectionBuyControls(
        this.arrayFees
      );
    }
    this.getCuotasSelected(
      this.bnplService.personalInformation.client ||
        localStorage.getItem('partner')
    );
    this.handleUpdateAuthorizationService();
    Swal.close();
  }

  private _filter(value: string): any[] {
    const filterValue = value.toLowerCase();
    return this.originData.filter((opt) =>
      opt.partnerName.toLowerCase().includes(filterValue)
    );
  }

  checkIfShouldRunAutomaticDebit() {
    this.handleAutomaticDebit();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkWindowSize();
  }

  checkWindowSize() {
    this.isLargeScreen = window.innerWidth >= 1260;
  }

  getSelectionBuys(data: any) {
    this.handlePostAutomaticDebit();
    let cleanValue = String(data.monto)
      .replace(/\./g, '')
      .replace(/[\s]|\$|,/g, '');
    this.bnplService.alertWait();
    localStorage.setItem('fun', 'A');
    localStorage.setItem('fees', data.numeroCuotas);
    localStorage.setItem('ammount', cleanValue);
    localStorage.setItem('C', 'cupo');
    let referenciaPago = data.referenciaPago;
    if (this.partnerName != '') {
      this.router.navigate(['/await-alert', 'ultimopaso']);
    } else {
      const data = {
        actionStrategyPattern: 'INFORMATION_CREDIT',
        id:
          this.bnplService.personalInformation.id || localStorage.getItem('id'),
        ammount:
          this.bnplService.personalInformation.ammount ||
          localStorage.getItem('ammount'),
        client:
          this.bnplService.personalInformation.client ||
          localStorage.getItem('partner'),
        term: localStorage.getItem('fees') || '',
        referencia:
          this.bnplService.personalInformation.referenciaPago || referenciaPago,
      };
      this.bnplService.getCreditCupo(data).subscribe((resp: any) => {
        this.navigationExtras = { state: resp };
        if (resp.showMessage == 1) {
          Swal.close();
          this.bnplService.openSnack(resp);
          this.appFormComponent.resetForm();
        }

        if (resp.showMessage == 2) {
          Swal.close();
          this.router.navigate(
            ['/await-alert', 'error'],
            this.navigationExtras
          );
        }

        if (resp.errorMessage) {
          this.router.navigate(['/await-alert', 'error-connection']);
        }

        if (
          resp.validationStrategy == 'OK' ||
          resp.validationStrategy == 'DOCUMENT'
        ) {
          this.bnplService.creditCupo = resp;
          this.router.navigate(['/summary-credit']);
        }
      });
    }
  }

  getCuotasSelected(clientSelected: any) {
    if (clientSelected != '' && clientSelected) {
      this.bnplService.clients.subscribe((resp: Client[]) => {
        this.arrayFees = [];
        const [client] = resp.filter((client) => client.id === clientSelected);
        localStorage.setItem('maxAmmount', client.maxAmmount.toString());
        localStorage.setItem('minAmmount', client.minAmmount.toString());
        localStorage.setItem('partnerName', client.partnerName);
        localStorage.setItem('partner', clientSelected);
        let j = 0;
        for (
          let i = client.minCreditTerm;
          i <= client.maxCreditTerm;
          i++, j++
        ) {
          this.arrayFees[j] = i;
        }
        if (this.commerce === 'true') {
          this.selectionBuy$ = this.bnplService.getSelectionPurchaseFees(
            this.arrayFees
          );
        } else {
          this.selectionBuy$ = this.bnplService.getSelectionBuyControls(
            this.arrayFees
          );
        }
      });
      this.desabledButton = false;
    }
  }

  handleUpdateAuthorizationService() {
    this.alertWait('Un momento por favor....');
    const numberId =
      this.bnplService.stepsInformation.firstStep.numeroDocumento;
    const body: IGetUpdateAuthorizationBody = {
      action: 'QUERIE',
      numberId: numberId,
    };
    this.updateAuthorizationService.getUpdateAuthorization(body).subscribe({
      next: (response) => {
        this.requireUpdate = response.requireUserDataUpdate;
        this.requireDebit = response.dataUpdateCustomer;
        if (response.requireUserDataUpdate || response.dataUpdateCustomer) {
          document.body.classList.add('no-scroll');
        }
        Swal.close();
      },
      error: (error) => {
        console.error('Error al obtener el estado', error);
      },
    });
  }

  alertWait(text: any) {
    Swal.fire({
      title: text,
      allowOutsideClick: false,
      imageUrl: '../../../../assets/img/LogoApprobe.gif',
      showConfirmButton: false,
      customClass: {
        image: 'alertImage',
      },
    });
  }

  filterPartner(store: Client) {
    this.branchFinder = store.partnerName;
    this.findListBranchs = null;
    if (store.blockTrade == 1) {
      this.desabledButton = true;
      this.dialog.open(DialogComponent, {
        data: {
          img: `${environment.urlAwsImg}/${store.id}.png`,
          description: store.blockMessage,
          descriptionSmall: store.blockMessageSmall
            ? store.blockMessageSmall
            : '',
          button: 'Volver',
          url: store.urlBackbuttom,
        },
        width: '60%',
        height: '60vh',
      });
    } else {
      this.getCuotasSelected(store.id);
    }
  }

  handleListStores() {
    this.bnplService.getClients().subscribe({
      next: (response) => {
        response.forEach((store) => {
          const key = store.brand;

          if (!this.storesList.has(key)) {
            this.storesList.set(key, []);
          }

          this.storesList.get(key)?.push(store);
        });
        console.log(this.storesList);
      },
      error: (error) => {
        console.error('Error al obtener el estado', error);
      },
    });
  }

  handleCarouselMaskTutoTimer(value: boolean) {
    this.carouselTuto = true;
    setTimeout(() => {
      this.handleCarouselMaskTuto(value);
    }, 5000);
  }

  handleCarouselMaskTuto(value: boolean) {
    this.carouselTuto = value;
  }

  filteredBranchs() {
    this.findListBranchs = null;
    this.selectedBranchStore = null;
    if (this.storeSelected) {
      const branch = this.branchFinder.toLowerCase();
      this.findListBranchs = this.storeSelected.filter((store) =>
        store.partnerName.toLowerCase().includes(branch)
      );
    }
  }

  handleResetBranch() {
    this.findListBranchs = null;
    this.selectedBranchStore = null;
    this.branchFinder = '';
  }

  handleAutomaticDebit() {
    if (
      !this.requireUpdate &&
      !this.autoDebitAccountSelected &&
      this.requireDebit
    ) {
      this.automaticDebit = true;
      document.body.classList.add('no-scroll');
    }
  }

  handlePostAutomaticDebit() {
    if (this.autoDebitAccountSelected) {
      this.automaticDebitService
        .postAutoDebitAccount(this.autoDebitAccountSelected)
        .subscribe({
          next: (response) => {
            console.log('Registro de debito en proceso');
          },
          error: (error) => {
            console.error('Error al intentar registrar el debito', error);
          },
        });
    }
  }
}

/**
  
 import { DialogDruo } from 'src/app/shared/components/dialog-druo/dialog-druo.component';
import { DialogDruoService } from 'src/app/shared/components/service/dialog-druo.service';
import { DataExperian } from '../../shared/models/dataExperian.model';
import { forkJoin } from 'rxjs';
  
  dataDruo: any = null
    private readonly serviceDruo: DialogDruoService,

    if (this.bnplService.druo.exists != 'S') {
      try {
        const dataBaNKS = {
          action: "GET_BANKS"
        }
  
        forkJoin({
          druoData: this.serviceDruo.getDataExperian(dataBaNKS),
          experianData: this.getDataBanksDruo()
        }).subscribe(({ druoData, experianData }) => {
          this.listBanks = druoData.lastLowLevelResult.scanResult.items;
          this.banksExperian = experianData; 
          this.openDialogDruo()
        });
      } catch (error) {
        Swal.close(); 
      }
    } 
try {
            const dataSendDruo = {
              action: "CONNECT_ACCOUNT",
              id: this.bnplService.druo.id,
              idInstitution: this.dataDruo.uuidBank,
              subType: this.dataDruo.subtype,
              accountNumber: this.dataDruo.numero,
              numberId: this.bnplService.stepsInformation.firstStep.numeroDocumento,
              change: this.dataDruo.change
            }
            this.serviceDruo.saveDataDruo(dataSendDruo).subscribe((res: any) => {
              if (res == "SUCCESS") {
                this.bnplService.druo.exists = 'S'
              }
              this.bnplService.creditCupo = resp;
              this.router.navigate(['/summary-credit']);
         
            })
          } catch (error) {
           
          }

            getDataBanksDruo() {
    let dataPersonal = this.bnplService.personalInformation;
    let dataSteps = this.bnplService.stepsInformation;

    const data = {
      tipoDocumento: "1",
      totalIncoming: "0",
      fees: this.bnplService.personalInformation.feesApprobe,
      identification: "CC",
      primerApellido:
        dataPersonal.primerApellido !== '' ? dataPersonal.primerApellido : dataSteps.secondStep.primerApellido,
      numeroDocumento:
        dataPersonal.identificacion !== '' ? dataPersonal.identificacion : dataSteps.firstStep.numeroDocumento,
      value: this.bnplService.creditEmit.amountFinance,
      feesApprobe: null,
      action: "GET_DATA_EXPERIAN"
    };

    return this.serviceDruo.getDataExperian(data); // Devuelve el Observable
  }

  openDialogDruo() {
        if (this.banksExperian) {
          const dialogRef = this.dialog.open(DialogDruo, {
            data: {banks: this.banksExperian, formData: this.dataDruo, listBanks: this.listBanks, validButton: true},
            width: '90%', 
            height: '90%',
            maxWidth: '568px',
            maxHeight: '686px',
            panelClass: 'custom-dialog-container'
            
          });
          dialogRef.afterClosed().subscribe(result => {
            this.dataDruo = result
          });
        } else {
          Swal.close()
        }
  }


 */
